import { URLS } from '../../../const/nav'

export const LOGIN_RESULT = {
  SUCCESS: 'success',
  INVALID_CREDENTIALS: 'invalid_credentials',
  ACCOUNT_DEACTIVATED: 'account_deactivated',
  SERVICE_UNAVAILABLE: 'service_unavailable'
}

export const useLogin = () => {
  const login = async (data) => {
    let response
    let body

    try {
      response = await fetch(`${URLS.BACKEND_URL}/usuarios/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: data.userName,
          clave: data.password
        })
      })
    } catch (networkError) {
      console.log(networkError)
      return { type: LOGIN_RESULT.SERVICE_UNAVAILABLE }
    }

    try {
      body = await response.json()
    } catch (parseError) {
      return { type: LOGIN_RESULT.SERVICE_UNAVAILABLE }
    }

    if (response.ok) {
      if (!body || !body.token || !body.rol) {
        return { type: LOGIN_RESULT.SERVICE_UNAVAILABLE }
      }
      return { type: LOGIN_RESULT.SUCCESS, token: body.token, rol: body.rol, data: body.data }
    }

    if (response.status === 401) {
      return { type: LOGIN_RESULT.INVALID_CREDENTIALS }
    }

    if (response.status === 403 && body?.error === 'ACCOUNT_DEACTIVATED') {
      return {
        type: LOGIN_RESULT.ACCOUNT_DEACTIVATED,
        mensaje: body.mensaje,
        soporteEmail: body.soporteEmail
      }
    }

    return { type: LOGIN_RESULT.SERVICE_UNAVAILABLE }
  }

  return { login }
}
